import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './main.scss';
import '@masterffl/ffl-grid-v2-component/dist/bundle.css'
// import '@masterffl/ffl-search-component/dist/bundle.css'
import '@masterffl/ffl-search-v2-component/dist/bundle.css'
import {
  ChakraProvider,
  createMultiStyleConfigHelpers,
  defineStyleConfig
} from '@chakra-ui/react';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { extendTheme } from '@chakra-ui/react';
import { switchAnatomy } from '@chakra-ui/anatomy';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import '@fontsource/lato/400-italic.css';
import '@fontsource/lato/700-italic.css';
import '@fontsource/lato/900-italic.css';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';
import AppConfig from './utils/app-config.mjs';
import * as Sentry from "@sentry/react";
import { LicenseManager } from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(AppConfig.agGridLicenseKey);

Sentry.init({
  dsn: `${AppConfig.dsn}`,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    `${AppConfig.backOfficeApiBaseURL}`,
    `${AppConfig.fflGetStoreApi}`,
    `${AppConfig.fflGetApiBaseURL}`,
    `${AppConfig.fflUILicenseApiBaseURL}`
  ],
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: `${AppConfig.environment}`,
});

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseToolTipStyle = {
  fontWeight: 'normal',
  minHeight: '29px',
  background: '#FFFFFF',
  borderRadius: '4px',
  boxShadow: '0px 0px 25px rgba(0, 0, 0, 0.15)',
  border: 'none'
};

const baseSwitchStyle = definePartsStyle({
  track: {
    bg: '#00000066',
    _checked: {
      bg: '#0C1E46'
    },
    _hover: {
      outline: 'none',
      border: 'none'
    }
  },
  thumb: {
    _hover: {
      outline: 'none',
      border: 'none'
    }
  }
});

const tooltipTheme = defineStyleConfig({ baseStyle: baseToolTipStyle });

const switchTheme = defineMultiStyleConfig({ baseStyle: baseSwitchStyle });

const theme = extendTheme({
  fonts: {
    heading: `'Lato', sans-serif`,
    body: `'Lato', sans-serif`
  },
  components: {
    Tooltip: tooltipTheme,
    Switch: switchTheme
  }
});


(function setDomain(){
  const hostname = window.location.hostname;
  let domainName = '';
  let appTitle = 'MasterFFL';
  if (hostname.includes('myffl.com')) {
    domainName = 'myffl.com';
    appTitle = 'MYFFL';
  } else if (hostname.includes('masterffl.com')) {
    domainName = 'masterffl.com';
    appTitle = 'MasterFFL';
  } else {
    domainName = '';
  }
  document.title = appTitle;
  localStorage.setItem('domainName', domainName);
})()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <Provider store={store}>
        <ToastContainer />
        <App />
      </Provider>
    </ChakraProvider>
  </React.StrictMode>
);
